<template>
  <div>
    <div class="container-xxl-fluid">
      <div class="row">
        <div :class="setClassDynamic" v-if="sliderList">
          <SliderList :slider-list="sliderList" ></SliderList>
        </div>
        <div :class="setClassDynamic">
          <BorcRiskSiparisBilgileri></BorcRiskSiparisBilgileri>
        </div>
        <div :class="setClassDynamic" class=" d-flex flex-column">
          <AylikCiroGrafigi
              style="flex-grow: 1; display: flex;"
              :dashboard-filter-current-code-prop="user.userInfo.erpCode"
          ></AylikCiroGrafigi>
        </div>
        <div :class="setClassDynamic" class="d-flex flex-column">
          <EnIyiSatilanUrunlerDonut
              :dashboard-filter-current-code-prop="user.userInfo.erpCode"
              style="flex-grow: 1; display: flex;"
          ></EnIyiSatilanUrunlerDonut>
        </div>
        <div class="col-lg-12">
          <EnIyiSatilanUrunler
              :dashboard-filter-current-code-prop="user.userInfo.erpCode"
              :title="'En İyi Stoklar'"
          ></EnIyiSatilanUrunler>
        </div>

        <div class="col-lg-12">
          <Son10Siparis
              :title="'Son 10 Sipariş'"
          >
            <template v-slot:filterAndAction>
              <v-btn @click="changePage()" small color="primary darken-1">TÜM SİPARİŞLER</v-btn>
            </template>
          </Son10Siparis>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BorcRiskSiparisBilgileri from "@/components/dashboard/BorcRiskSiparisBilgileri/BorcRiskSiparisBilgileri";
import SliderList from "@/components/dashboard/SliderList/SliderList";
import AylikCiroGrafigi from "@/components/dashboard/AylikCiroGrafigi/AylikCiroGrafigi";
import EnIyiSatilanUrunler from "@/components/dashboard/EnIyiSatilanUrunler/EnIyiSatilanUrunler";
import Son10Siparis from "@/components/dashboard/Son10Siparis/Son10Siparis";
import EnIyiSatilanUrunlerDonut from "@/components/dashboard/EnIyiSatilanUrunler/EnIyiSatilanUrunlarDonut.vue";
import {mapActions, mapState} from "vuex";

export default {
  name: "CustomerDashboard",
  components: {
    EnIyiSatilanUrunlerDonut,
    AylikCiroGrafigi,
    EnIyiSatilanUrunler,
    Son10Siparis,
    SliderList,
    BorcRiskSiparisBilgileri
  },
  data() {
    return {
      panel: 0,
      dynamicClass: "",
      showDialog: false,
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("slider", ["sliderList"]),
    ...mapState("auth", ["showCustomerModal"]),

    setClassDynamic() {
      return this.sliderList ? "col-lg-6" : "col-lg-12";
    }
  },
  mounted() {
    this.fetchSliderList({
      params: {
        userId: this.user.UserId,
      },
      body: {},
    });
  },
  methods: {
    ...mapActions("slider", ["fetchSliderList"]),
    changePage() {
      this.$router.push({name: 'orderList'})
    },
  },
}
</script>

<style scoped>

</style>
